<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>EV Charging Mission</title>
  <style>
    html,
    body {
      margin: 0;
      padding: 0;
      min-height: 100vh;
      font-family: Arial, sans-serif;
      display: flex;
      flex-direction: column;
    }

    header {
      background-color: #000;
      color: white;
      text-align: center;
      padding: 15px 10px;
    }

    main {
      padding: 20px;
      max-width: 800px;
      margin: auto;
      flex: 1;
    }

    h1 {
      font-size: 24px;
      margin: 0;
    }

    h2 {
      font-size: 20px;
      margin-top: 20px;
      margin-bottom: 10px;
      color: black;
    }

    p {
      font-size: 16px;
      line-height: 1.6;
      color: grey;
    }

    footer {
      background-color: #000;
      color: white;
      text-align: center;
      padding: 15px 10px;
      width: 100%;
    }

    @media (max-width: 600px) {
      h1 {
        font-size: 20px;
      }

      h2 {
        font-size: 18px;
      }

      p {
        font-size: 15px;
      }

      header,
      footer {
        font-size: 14px;
      }
    }
  </style>
</head>

<body>


  <main>
    <p style="color:black">Effective April 21, 2025</p>
    <a href="https://admin.plugp2p.com/our-mission/Redirection"
      style="font-weight: bold; color: black; text-decoration: underline;">Our Mission</a>

    <p style="color: black;margin-top: 16px;">Transform EV Charging.</p>

    <p style="font-size: 14px;">Empower owners of qualified devices to share, make extra income, and help others.

      Enable EV Drivers to discover more and better EV charging options.

      Transform the EV Charging paradigm to uplift Charge Hosts, Charge Guests, and our communities.</p>
  </main>


</body>

</html>